export const preserveDate = (oldDate, newDate) => {    
    if (!oldDate) {
        return newDate
    }

    const h = newDate.getHours()
    const m = newDate.getMinutes()
    const ph = oldDate.getHours()
    const pm = oldDate.getMinutes()

    if (h === 0 && m === 0 && ph !== 0 && pm !== 0) {
        newDate.setHours(ph)
        newDate.setMinutes(pm)
    }

    return newDate
}


// WEBPACK FOOTER //
// src/lib/DateUtils.js